import React from 'react';
import { defaultTheme } from '../../../__core/Themes/Default';
import PASS_STATUS from '../../../__core/Enums/PassStatus';

type MenuMaterialStatusProps = {
  status: PASS_STATUS;
};

const MenuMaterialStatus: React.FunctionComponent<MenuMaterialStatusProps> = ({
  status,
}): React.ReactElement => {
  const fillColor =
    status === PASS_STATUS.DONE
      ? defaultTheme.UI_COLORS.success
      : defaultTheme.UI_COLORS.main_gray;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
    >
      <circle cx="5" cy="5" r="5" fill={fillColor} />
    </svg>
  );
};

export default MenuMaterialStatus;
